module.exports = __webpack_public_path__ + "static/media/play-arrow-white.72deaf2d.svg";